<script setup lang="ts">
  import { Item } from '@borg/types';
  import { MpField, MpRadio } from '@borg/ui';

  const props = defineProps<{
    modelValue: Item[];
    options: Item[];
    error?: string;
  }>();

  const emit = defineEmits<{
    (e: 'update:modelValue', value?: [Item] | []): void;
  }>();

  function onClick(option: Item) {
    if (props.modelValue[0]?.id === option.id) {
      emit('update:modelValue', []);
    } else {
      emit('update:modelValue', [option]);
    }
  }
</script>

<template>
  <MpField
    :error="error"
    class="field"
  >
    <div class="field">
      <MpRadio
        v-for="option in options"
        :key="option.id"
        :model-value="modelValue[0]"
        :value="option"
        :label="option.name"
        @click="onClick(option)"
      />
    </div>
  </MpField>
</template>

<style scoped lang="scss">
  .field {
    display: flex;
    flex-direction: column;
    gap: var(--mp-space-20);
    margin-bottom: var(--mp-space-20);
  }
</style>
